module.exports = __webpack_public_path__ + "static/media/shaolingong.92ee4f2e.mp3";